module.exports = __webpack_public_path__ + "media/newstyle/images/icon-chat-orange-10b563d2b587a880f791192b168ae335.svg";